import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

export interface CompanyListParamsType {
  order: string;
  page: number;
}
export interface ListCompanyDataType {
  successCallback?: Function;
  errorCallback?: Function;
  resultKey?: string;
  params: CompanyListParamsType;
}

export default ({ successCallback, errorCallback, resultKey = 'listCompanyData', params }: ListCompanyDataType) =>
  requestAsync({
    url: endpoints.getCompanyListUrl(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getCompanyListUrl(params),
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
